import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['inputField', 'hiddenFormField'];

  connect() {
    this.updateValue()
  }

  input(event) {
    this.updateValue()
  }

  // Handle keydown to prevent non-numeric input
  keydown(event) {
    // Allow control keys
    if (['Backspace', 'Tab', 'Enter'].includes(event.key)) {
      return
    }

    // Prevent non-numeric characters
    if (!/^\d$/.test(event.key)) {
      event.preventDefault()
    }
  }

  // Update the text field with the formatted value
  // and update the hidden field with the raw cents value
  updateValue() {
    if(this.inputFieldTarget.value == null) {
      this.inputFieldTarget.value = ""
    }

    // Get current cursor position
    const cursorPosition = this.inputFieldTarget.selectionStart
    const oldLength = this.inputFieldTarget.value.length

    // Remove all non-numeric characters and leading zeros
    let value = this.inputFieldTarget.value
      .replace(/\D/g, '')
      .replace(/^0+/, '')

    // If empty, set to 0,00
    if (value === '') {
      value = '000'
    }

    // Pad with zeros if less than 3 digits
    if (value.length === 1) {
      value = '00' + value
    } else if (value.length === 2) {
      value = '0' + value
    }

    // Insert decimal separator (comma)
    const integerPart = value.slice(0, -2)
    const decimalPart = value.slice(-2)

    // Format integer part with thousand separators (dots)
    const formattedInteger = this.addThousandSeparators(integerPart)

    // Combine with decimal part
    const formattedValue = formattedInteger + ',' + decimalPart

    // Update the input value and the hidden input value
    this.inputFieldTarget.value = formattedValue
    this.hiddenFormFieldTarget.value = this.centsValue();

    // Restore cursor position
    const newLength = formattedValue.length
    const lengthDiff = newLength - oldLength
    let newCursorPosition = cursorPosition + lengthDiff
    newCursorPosition = Math.min(newCursorPosition, newLength)
    newCursorPosition = Math.max(0, newCursorPosition)
    this.inputFieldTarget.setSelectionRange(newCursorPosition, newCursorPosition)
  }

  // Add thousand separators (dots) to integer part
  addThousandSeparators(value) {
    // Convert to number and back to remove any leading zeros
    const num = parseInt(value, 10)
    if (num === 0) return '0'

    // Add dots as thousand separators
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  }

  // Method to get raw cents value
  centsValue() {
    return parseInt(this.inputFieldTarget.value.replace(/\D/g, ''))
  }

  // Method to set value programmatically (expects cents)
  setValue(cents) {
    const centsStr = Math.abs(Math.round(cents)).toString();
    this.inputFieldTarget.value = centsStr;
    this.updateValue();
  }
}
